import http from 'hub-http/clients/apiClient';
import getFromEarlyRequest from 'forms-utils-lib/earlyRequest/getFromEarlyRequest';
// @ts-expect-error untyped dependency
import { getThemesKey } from 'FormsUI/earlyRequest/earlyRequestsShared';
const BASE_URL = '/forms/v2';
export function _getFormThemes() {
  return http.get(`${BASE_URL}/themes`);
}
export const getFormThemes = () => getFromEarlyRequest(getThemesKey(), () => _getFormThemes());